module.exports = __webpack_public_path__ + "static/media/production.960cc10b.svg";